module.exports = __webpack_public_path__ + "assets/img/CRM.fa8ea79a.svg";